<template>
  <div no-body class="p-2 font-inter">
    <b-row>
      <b-col cols="4" class="font-weight-bold font-12 pb-2">
        {{ $t('views.seller.sales.text_1390') }}
      </b-col>
      <b-col cols="1" class="font-weight-bold font-12 px-0 py-1 text-right">
        {{ $t('views.seller.sales.text_1391') }}
      </b-col>
      <b-col cols="2" class="font-weight-bold font-12 px-0 py-1 text-center">
        {{ $t('views.seller.sales.text_1392') }}
      </b-col>
      <b-col cols="2" class="border-left font-weight-bold font-12 px-0 py-1 text-right">
        {{ $t('views.seller.sales.text_1391') }}
      </b-col>
      <b-col cols="3" class="font-weight-bold font-12 px-0 py-1 text-center">
        {{ $t('views.seller.sales.high_ticket_commission') }}
      </b-col>
    </b-row>

    <b-row v-for="(value, key) in indicated.comission" :key="key">
      <b-col cols="4" class="font-12">
        {{ $t('views.seller.sales.' + labelFees[key]) }}
      </b-col>
      <b-col cols="1" class="px-0 py-1 text-center">
        <div v-if="
          indicated.indicated_seller_fee_type[key] == 'percent'
        " class="font-12 float-left">
          %
        </div>
        <div v-else class="font-12 float-left"> R$ </div>
        <div class="font-12 float-right">
          {{
            indicated.indicated_seller_fee[key]
              ? formatMoney(indicated.indicated_seller_fee[key])
              : '0,00'
          }}
        </div>
      </b-col>
      <b-col cols="2" class="font-12 px-0 py-1 text-center">
        {{
          value
            ? formatMoney(value)
            : '0,00'
        }}
        %
      </b-col>
      <b-col cols="2" class="border-left px-0 py-1 text-center">
        <div v-if="
          indicated.high_ticket_indicated_seller_fee_type[key] == 'percent'
        " class="font-12 float-left pl-5">
          %
        </div>
        <div v-else class="font-12 float-left pl-5"> R$ </div>
        <div class="font-12 float-right">
          {{
            indicated.high_ticket_indicated_seller_fee[key]
              ? formatMoney(indicated.high_ticket_indicated_seller_fee[key])
              : '0,00'
          }}
        </div>
      </b-col>
      <b-col cols="3" class="font-12 px-0 py-1 text-center">
        {{
          indicated.high_ticket_comission[key]
            ? formatMoney(indicated.high_ticket_comission[key])
            : '0,00'
        }}
        %
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Money from '@/mixins/money';

export default {
  name: 'Comission',
  mixins: [Money],
  props: {
    indicated: {
      type: Object
    },
  },
  data() {
    return {
      labelFees: {
        BOLETO: 'text_1393',
        CREDIT_CARD: 'text_1394',
        INTERNATIONAL_CREDIT_CARD: 'text_1395',
        PAYPAL: 'text_1396',
        PIX: 'text_1397'
      }
    }
  },
  methods: {
  },
};
</script>

<style scoped>
</style>
